/** Lightbox modal for viewing full-size product infographics. */
import { useEffect } from "react";
import { X } from "lucide-react";

export default function ImageLightbox({ src, alt, onClose }) {
  useEffect(() => {
    if (!src) return;
    document.body.style.overflow = "hidden";
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [src, onClose]);

  if (!src) return null;

  return (
    <div
      data-testid="image-lightbox"
      className="fixed inset-0 z-[100] grid place-items-center p-4 lg:p-8"
      style={{ background: "rgba(2,6,12,0.92)", backdropFilter: "blur(12px)" }}
      onClick={onClose}
    >
      <button
        data-testid="image-lightbox-close"
        onClick={onClose}
        className="absolute top-5 right-5 z-10 w-10 h-10 grid place-items-center rounded-full border border-white/15 bg-white/5 text-white hover:bg-white/10 transition-colors"
        aria-label="Close"
      >
        <X className="w-4 h-4" />
      </button>

      <img
        src={src}
        alt={alt}
        onClick={(e) => e.stopPropagation()}
        className="max-w-[95vw] max-h-[92vh] rounded-xl border border-white/10 shadow-2xl"
        style={{ boxShadow: "0 0 0 1px rgba(245,166,35,0.35), 0 0 60px rgba(245,166,35,0.2)" }}
      />

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-[0.65rem] font-mono uppercase tracking-[0.3em] text-white/40">
        Press ESC to close
      </div>
    </div>
  );
}
